$mol_view_tree2_to_js_test_ex_structural_localized_prop_value_foo $mol_object
	bar *
		loc @ \\v1
		baz *
			loc2 @ \\v2
